/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../magnolia/lib/MagnoliaPropertyHelper';

export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface bottomLevelLinksStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
  showLinkKiosk ? : boolean;
  showLinkCatalog ? : boolean;
}
export default interface Footer {
  column: any;
  brands: any;
  categoriesLinks: any;
  mobileDisplayMode: string;
  bottomLevelLinks ? : Array < bottomLevelLinksStruct > ;
  metadata ? : any;
}

export const Props = {
  column: Object,
  brands: Object,
  categoriesLinks: Object,
  mobileDisplayMode: String,
  bottomLevelLinks: Array as() => Array < bottomLevelLinksStruct > ,
  metadata: Object,
}

export const WrapperProps = {
  column: Object,
  brands: Object,
  categoriesLinks: Object,
  mobileDisplayMode: String,
  bottomLevelLinks: Object,
  metadata: Object,
}

export class FooterBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class FooterInstance implements Footer {
      mobileDisplayMode: string;
      bottomLevelLinks ? : Array < bottomLevelLinksStruct > ;
      column: any;
      brands: any;
      categoriesLinks: any;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.bottomLevelLinks) {
          this.bottomLevelLinks = Object.entries(this.bottomLevelLinks)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'bottomLevelLinks' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.bottomLevelLinks.length; i1++) {

            if (this.bottomLevelLinks[i1]) {
              if (this.bottomLevelLinks[i1].switchable) {
                if (typeof this.bottomLevelLinks[i1].switchable.download === 'object') {
                  this.bottomLevelLinks[i1].switchable.download = {
                    ...this.bottomLevelLinks[i1].switchable.download,
                    link: this.bottomLevelLinks[i1].switchable.download['@link'],
                    name: this.bottomLevelLinks[i1].switchable.download['@name'],
                    path: this.bottomLevelLinks[i1].switchable.download['@path'],
                  };
                } else {
                  this.bottomLevelLinks[i1].switchable.download = null as any;
                }
              }
            }
          }
        } else {
          this.bottomLevelLinks = null as any;
        }
      }
    }
    return new FooterInstance(props);
  }
}
